import { FC, memo, ReactElement, useMemo } from 'react'
import { Box, Flex, FlexProps, Heading, Text } from '@chakra-ui/react'

import { EmptyDrawerIllustration, EmptyFolderIllustration } from 'components'

type Props = FlexProps & {
  illustration?: 'EmptyFolder' | 'EmptyDrawer'
  title?: string
  description?: string
  children?: ReactElement
}

const Empty: FC<Props> = ({
  illustration = 'EmptyFolder',
  title,
  description,
  children,
  height = '300px',
  ...rest
}) => {
  const RenderIllustration = useMemo(() => {
    const views = {
      EmptyFolder: <EmptyFolderIllustration size="150px" />,
      EmptyDrawer: <EmptyDrawerIllustration size="150px" />,
    }

    return views[illustration]
  }, [])

  return (
    <Flex p={4} gap={4} height={height} direction="column" align="center" justify="center" {...rest}>
      <Flex direction="column" align="center" justify="center" gap={2}>
        {RenderIllustration}

        <Heading textAlign="center">{title}</Heading>

        {description && (
          <Text variant="secondary" textAlign="center">
            {description}
          </Text>
        )}

        {children && <Box mt={2}>{children}</Box>}
      </Flex>
    </Flex>
  )
}

export default memo(Empty)
